import React from 'react';

// Rende visibile lo stato della connessione. Prima, su una chiusura non
// gestita, la pagina restava semplicemente ferma con dati vecchi e nessun
// segnale.

export default function ConnectionBanner({ connection, staleProtocol, onRejoin }) {
    if (staleProtocol) {
        return (
            <div className="connection-banner connection-banner--warn">
                <span>
                    L&apos;applicazione e stata aggiornata mentre eri collegato.
                </span>
                <button
                    type="button"
                    className="connection-banner-action btn btn--primary"
                    onClick={() => window.location.reload()}
                >
                    Ricarica
                </button>
            </div>
        );
    }

    if (connection.closedReason) {
        return (
            <div className="connection-banner connection-banner--stop">
                <span>{connection.closedReason}</span>
                {onRejoin && (
                    <button
                        type="button"
                        className="connection-banner-action btn btn--primary"
                        onClick={onRejoin}
                    >
                        Rientra
                    </button>
                )}
            </div>
        );
    }

    if (connection.reconnecting) {
        return (
            <div className="connection-banner connection-banner--warn">
                <span>Connessione persa. Sto riprovando…</span>
            </div>
        );
    }

    return null;
}
